module.exports = __webpack_public_path__ + "img/wangxiaoxuan.5838dcf2.jpg";